import { useEffect } from 'react';

import { ENV_VARS } from '@/env';
import { isValidUrl } from '@/utilz';

export const useNewDomainRedirect = () => {
  useEffect(() => {
    const targetBaseUrl = ENV_VARS.REACT_APP_NEW_DOMAIN_URL;
    if (!targetBaseUrl || !isValidUrl(targetBaseUrl)) {
      return;
    }

    try {
      const current = window.location;
      const target = new URL(targetBaseUrl);

      if (current.origin !== target.origin) {
        target.search = current.search;
        target.hash = current.hash;
        target.pathname = current.pathname;
        window.location.replace(target.toString());
      }
    } catch (error) {
      console.error('Domain redirect failed:', error);
    }
  }, []);
};
